<template>
  <div class="book">
    <img :src="data.imgSrc" alt="书本图片">
    <div class="info">
      <p class="name" :title="data.name">{{ data.name }}</p>
      <p class="author">
        <img src="../../assets/man_black.png">
        <span>{{ data.author }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'book',
  props: {
    // {imgSrc: '', name: '', author: ''}
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .book {
    display: flex;
    width: 150px;
    flex-direction: column;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .15);
  }

  img {
    width: 150px;
    height: 200px;
  }

  .info {
    display: flex;
    flex-direction: column;
    padding: 12px 0;
  }

  .name {
    @include hideTextOverflow;
    font-size: 20px;
    text-align: center;
  }

  .author {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    color: #999;
    font-size: 12px;
    text-align: center;
    img {
      margin-right: 8px;
      width: 16px;
      height: 16px;
      opacity: .6;
    }
    span {
      margin-top: 2px;
    }
    // span::before {
    //   content: url("../../assets/man_black.png");
    //   // position: absolute;
    //   right: 4px;
    //   width: 2px;
    //   height: 2px;
    //   opacity: .6;
    // }
  }
</style>